<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    button{
        background: none;
    }
</style>
<template>
    <button class="btn" @click="sendMessage">{{val}}</button>
</template>
<script>
    export default {
        name: '',
        data() {
            return {
                val: this.msg,
                status:false,
                time: '',
            }
        },
        props: ['times','msg','events','type','uuid','phone','code'],
        methods: {
            sendMessage: function() {
                event.preventDefault()
                let _this = this
                let param = {
                    uuid:_this.uuid,
                    phoneNum:_this.phone,
                    code:_this.code,
                    type:_this.type
                }
                if(!_this.code){
                    delete param.code
                }
                if(this.status){
//                    site._post('get_verify_code_by_type_wx.cgi',param,this,_this.callback,_this.error)
                }
            },
            callback: function (data) {
                let _this = this
                if(site._checkFun(_this.events)){
                    _this.events.apply(this,[data])
                }
                if(_this.status){
                    site.getLocal('backTime',new Date().getTime())
                }
                _this.status = false
                let set = setInterval(function(){
                    _this.time -= 1
                    _this.val = '倒计时'+_this.time+'秒'
                    if(_this.time == 0){
                        clearInterval(set)
                        _this.clear()
                    }
                },1000)
            },
            clear: function () {
                this.status = true
                this.val = '重新发送'
                this.time = this.getTime()
            },
            error: function () {

            },
            getTime: function(){
                let time = site.getLocal('backTime') ? (new Date().getTime()-site.getLocal('backTime'))/1000: null
                return time&&time<this.times?this.times - parseInt(time):this.times
            }
        },
        components: {},
        mounted() {
            this.$nextTick(function() {
                this.time = this.getTime()
                if(this.time != 60&&this.time > 0){
                    this.val = '倒计时'+this.time+'秒'
                    this.callback()
                }else{
                    this.status = true
                }
            })
        },
        created() {
        }
    }
</script>


// WEBPACK FOOTER //
// backTime.vue?777effa4